<template>
    <div class="login-footer">
        <div class="login-footer__actions">
            <div class="login-footer__action-primary">
                <button class="btn btn-secondary login-footer__btn-primary" @click="primaryClickHandler">{{ ctaText }}</button>
            </div>

            <div v-if="authenticationStep == 'LoginPass' || authenticationStep == 'LoginWelcome'" class="login-footer__action-forgot">
                <a class="login-footer__btn-forgot" type="button" @click="nextStep">Zapomněli jste heslo?</a>
            </div>
            <div v-if="authenticationStep == 'ForgPinGen' || authenticationStep == 'ForgPinLog'" class="login-footer__action-login">
                Vzpomněli jste si na své heslo?
                <a class="login-footer__btn-login" type="button" @click="goToLoginPass">Přihlaste se</a>
            </div>
        </div>
        <div class="login-footer__apps" v-if="authenticationStep == 'LoginWelcome'">
            <div class="login-footer__apps-intro">Sazka Klub nyní ve Vašem telefonu:</div>
            <div class="login-footer__apps-list">
                <a class="login-apps-button" href="https://www.sazka.cz/sazka-klub/aplikace" is-external="true">
                    <WebpImage
                        src="/frontend/kasa-loyalty/img/icons/colored/app-android.svg"
                        :alt="`Ikona android`"
                        cssClass="login-apps-button__icon"
                    />
                    <div class="login-apps-button__text">
                        <div class="login-apps-button__text--top">Stáhnout pro</div>
                        <div class="login-apps-button__text--bottom">Android</div>
                    </div>
                </a>
                <a class="login-apps-button" href="https://www.sazka.cz/sazka-klub/aplikace" is-external="true">
                    <WebpImage
                        src="/frontend/kasa-loyalty/img/icons/colored/app-ios.svg"
                        :alt="`Ikona iOS`"
                        cssClass="login-apps-button__icon"
                    />
                    <div class="login-apps-button__text">
                        <div class="login-apps-button__text--top">Stáhnout pro</div>
                        <div class="login-apps-button__text--bottom">iOS</div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { AuthenticationStepType } from "@/account/models/authentication-flows";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { computed } from "vue";

const emit = defineEmits(["nextStep", "goToLoginPass", "login"]);

const props = defineProps<{
    authenticationStep: AuthenticationStepType;
}>();

const ctaText = computed(() => {
    switch (props.authenticationStep) {
        case "LoginWelcome":
        case "LoginPhone":
        case "LoginPass":
            return "Přihlásit se";
        case "ForgPinGen":
            return "Odeslat PIN kód";
        case "ForgPinLog":
            return "Ověřit kód";
        case "ForgNewPass":
            return "Uložit heslo";
        case "ForgNewPassOk":
            return "Zavřít";
        default:
            return "Pokračovat";
    }
});

const primaryClickHandler = () => {
    if (props.authenticationStep == "LoginPass" || props.authenticationStep == "LoginWelcome") {
        emit("login");
    } else {
        emit("nextStep");
    }
};

const nextStep = () => {
    emit("nextStep");
};

const goToLoginPass = () => {
    emit("goToLoginPass");
};
</script>
